import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { UserContextService } from '@sentry/user-context';
import { PermissionCode } from './permission-code';

@UntilDestroy()
@Directive({
    selector: '[sentryHasAnyPermission]',
    standalone: true
})
export class HasAnyPermissionDirective {
  constructor(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private readonly userContextService: UserContextService
  ) {}

  @Input() set sentryHasAnyPermission(permissionCodes: PermissionCode[]) {
    this.userContextService.permissions$
      .pipe(untilDestroyed(this))
      .subscribe((permissions) => {
        const hasPermission = permissions.some((p) =>
          permissionCodes.some((code) => code === p.code)
        );

        if (hasPermission) {
          this.viewContainer.createEmbeddedView(this.templateRef);
        } else {
          this.viewContainer.clear();
        }
      });
  }
}
